import type { DimensionAnnotation, WindZoneGeometry } from '../../gen/ejot/roofing/v1/types';

/**
 * Once a calculation exists its geometry is the canonical visual source.
 * Preview geometry is used only before a calculation or when the calculated
 * response carries no drawable geometry. An empty preview must never mask a
 * valid calculated result.
 */
export function selectAuthoritativeZones(
  calculated: readonly WindZoneGeometry[] | undefined,
  preview: readonly WindZoneGeometry[] | undefined,
): readonly WindZoneGeometry[] {
  return calculated && calculated.length > 0 ? calculated : (preview ?? []);
}

/** Calculated dimensions win when present; otherwise the backend preview supplies them. */
export function selectAuthoritativeDimensions(
  calculated: readonly DimensionAnnotation[] | undefined,
  preview: readonly DimensionAnnotation[] | undefined,
): readonly DimensionAnnotation[] {
  return calculated && calculated.length > 0 ? calculated : (preview ?? []);
}
